// http.js

import axios from 'axios';

const baseURL = process.env.NODE_ENV === 'production' ? 'https://api.jsd-express.cn' : 'https://api-dev.jsd-express.cn';
// const baseURL = 'http://192.168.2.104:48080'
const instance = axios.create({
  baseURL,
});

instance.interceptors.request.use(
  config => {
    // config.header = {
    //     ...config.header,
    //     "X-Access-Token": getTokenStorage(),
    //     "X-KY-TIMESTAMP": generateRandomTimestamp(),
    //     // "X-MASF-DEBUG": "true", // 测试获取验证码
    //   };
    // 在发送请求之前做些什么
    // 可以在这里添加请求头等信息
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response;
  },
  error => {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default instance;
